const normalizeText = (value) => (value ?? '').toString().trim().toLowerCase();

const isNumericMismatch = (actual, extracted, tolerance = 0.01) => {
    if (extracted === null || extracted === undefined || extracted === '') return false;
    const a = Number(actual);
    const b = Number(extracted);
    if (Number.isNaN(a) || Number.isNaN(b)) return false;
    return Math.abs(a - b) >= tolerance;
};

const isTextMismatch = (actual, extracted) => {
    if (extracted === null || extracted === undefined || extracted === '') return false;
    return normalizeText(actual) !== normalizeText(extracted);
};

const isDateMismatch = (actual, extracted) => {
    if (extracted === null || extracted === undefined || extracted === '') return false;
    if (!actual) return true;
    return normalizeText(actual).slice(0, 10) !== normalizeText(extracted).slice(0, 10);
};

// Priority for the label: manual edit > system default > mismatch > PDF.
// `mismatch`/`pdfValue` are tracked independently of source either way.
const getFieldSource = (value, extractedValue, isSystemDefaulted, compareFn, isManuallyEdited = false) => {
    const hasExtracted = extractedValue !== null && extractedValue !== undefined && extractedValue !== '';
    const mismatch = hasExtracted && compareFn(value, extractedValue);
    let source;
    if (isManuallyEdited) {
        source = 'Manual';
    } else if (isSystemDefaulted) {
        source = 'System';
    } else if (mismatch) {
        source = 'Manual';
    } else if (hasExtracted) {
        source = 'PDF';
    } else {
        return null;
    }
    return { source, pdfValue: hasExtracted ? extractedValue : null, mismatch };
};

export { isNumericMismatch, isTextMismatch, isDateMismatch, getFieldSource };
